import React, { Fragment } from "react";
import { PortableText } from "@portabletext/react";
import { normalizeInternalPath } from "../../utils/normalizeInternalPath";

export default function PortableContent({
    data,
    linkColor = "text-secondary",
}) {
    return (
        <Fragment>
            {data && (
                <PortableText
                    value={data}
                    components={{
                        block: {
                            h2: ({ children }) => (
                                <h2>{children}</h2>
                            ),
                            h3: ({ children }) => (
                                <h3>{children}</h3>
                            ),
                            normal: ({ children }) => (
                                <p>{children}</p>
                            ),
                        },
                        marks: {
                            color: ({ value, children }) => (
                                <span style={{ color: value.hex }}>{children}</span>
                            ),
                            link: ({ value, children }) => {
                                const href = value?.href || "";
                                const isExternal = /^(https?:\/\/|mailto:|tel:)/i.test(
                                    href
                                );
                                const target = isExternal ? "_blank" : undefined;
                                return (
                                    <a
                                        href={
                                            isExternal
                                                ? href
                                                : normalizeInternalPath(href)
                                        }
                                        target={target}
                                        rel={target === "_blank" && "noindex nofollow"}
                                        className={`transition-colors duration-150 ease-linear ${linkColor}`}
                                    >
                                        {children}
                                    </a>
                                );
                            },
                            strong: ({ children }) => (
                                <strong style={{ color: 'white' }}>{children}</strong>
                            ),
                        },
                    }}
                />
            )}
        </Fragment>
    );
}
